import { WorkoutSportType } from '../../types/sport.type';

/**
 * Identifiant numerique de chaque sport attendu par l'API (`sport`), repris du legacy.
 */
export const WORKOUT_SPORT_IDS: Readonly<Record<WorkoutSportType, number>> = {
  cycling: 1,
  running: 2,
  rowing: 4,
  elliptical: 3,
};
